import { DashboardType, type EntitlementKey } from "@doitintl/cmp-models";

import { useIsFeatureEntitledMultiple } from "../../../Context/TierProvider";
import { useCurrentDashboardContext } from "../../../Context/useCurrentDashboardContext";

const dashboardTypeToEntitlementMap: Partial<Record<DashboardType, EntitlementKey>> = {
  [DashboardType.AWSMAPLens]: "lens:awsmap",
  [DashboardType.AwsLens]: "lens:aws",
  [DashboardType.AzureLens]: "lens:azure",
  [DashboardType.BqLens]: "lens:bigquery",
  [DashboardType.DatadogLens]: "datadog:connect",
  [DashboardType.OpenAILens]: "openai:connect",
  [DashboardType.EKSLens]: "lens:eks",
  [DashboardType.GcpLens]: "lens:gcp",
  [DashboardType.GkeLensV2]: "lens:gke",
  [DashboardType.Pulse]: "dashboard:pulse",
  [DashboardType.SaaSAwsLens]: "lens:aws",
  [DashboardType.SaaSGcpLens]: "lens:gcp",
  [DashboardType.SnowflakeLens]: "snowflake:connect",
};

const customDashboardEntitlementKey: EntitlementKey = "dashboard:custom";
const entitlementKeys = Object.values(dashboardTypeToEntitlementMap);
entitlementKeys.push(customDashboardEntitlementKey);

export function useIsEntitledToCurrentDashboardType() {
  const { dashboardType, currentDashboard } = useCurrentDashboardContext();
  const featuresEntitlements = useIsFeatureEntitledMultiple(entitlementKeys);

  // Only global dashboards have a dashboard type
  const isGlobalDashboard = currentDashboard ? Boolean(currentDashboard.dashboardType) : false;

  if (!isGlobalDashboard) {
    return Boolean(featuresEntitlements[customDashboardEntitlementKey]);
  }

  if (!dashboardType) {
    return false;
  }

  const entitlementKey = dashboardTypeToEntitlementMap[dashboardType];
  if (entitlementKey) {
    return Boolean(featuresEntitlements[entitlementKey]);
  }

  return false;
}
